import { gql } from '@apollo/client';

const START_STREAM_ECG_MUTATION = gql`
  mutation startStreamECG($input: StreamECGInput!) {
    startStreamECG(input: $input) {
      isSuccess
      message
    }
  }
`;

export default START_STREAM_ECG_MUTATION;
